export enum GotoType {
  None,
  Shipment,
  Filter,
}
